
import React from "react";
import {
  TextField,
  Grid,
  Typography,
  FormControl,
  FormLabel,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
} from "@mui/material";

const BuyerInfoForm = ({
  editableInvoice,
  handleInputChange,
  isDisabled,
  stripePaymentEnabled,
  documentType,
  countries,
  countryValue,
  provinces,
  provinceValue,
}) => {
  return (
    <>
      <Typography variant="subtitle1" className="mb-2 fw-bold">
        Buyer Information
      </Typography>
      <Grid container spacing={2} className="mb-3">
        <Grid item xs={12} sm={6}>
          <TextField
            label="Company Name"
            value={editableInvoice.buyer.companyName || ""}
            onChange={(e) =>
              handleInputChange("buyer", {
                ...editableInvoice.buyer,
                companyName: e.target.value,
              })
            }
            fullWidth
            disabled={true}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Billed To"
            value={editableInvoice.buyer.contact.name || ""}
            onChange={(e) =>
              handleInputChange("buyer", {
                ...editableInvoice.buyer,
                contact: {
                  ...editableInvoice.buyer.contact,
                  name: e.target.value,
                },
              })
            }
            fullWidth
            disabled={isDisabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Email"
            value={editableInvoice.buyer.contact.email || ""}
            onChange={(e) =>
              handleInputChange("buyer", {
                ...editableInvoice.buyer,
                contact: {
                  ...editableInvoice.buyer.contact,
                  email: e.target.value,
                },
              })
            }
            fullWidth
            disabled={isDisabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Phone"
            value={editableInvoice.buyer.contact.phone || ""}
            onChange={(e) =>
              handleInputChange("buyer", {
                ...editableInvoice.buyer,
                contact: {
                  ...editableInvoice.buyer.contact,
                  phone: e.target.value,
                },
              })
            }
            fullWidth
            disabled={isDisabled}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} className="mb-3">
        <Grid item xs={12} sm={6}>
          <TextField
            label="Address"
            value={editableInvoice.buyer.address.fullAddress || ""}
            onChange={(e) =>
              handleInputChange("buyer", {
                ...editableInvoice.buyer,
                address: {
                  ...editableInvoice.buyer.address,
                  fullAddress: e.target.value,
                },
              })
            }
            fullWidth
            disabled={isDisabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="City"
            value={editableInvoice.buyer.address.city || ""}
            onChange={(e) =>
              handleInputChange("buyer", {
                ...editableInvoice.buyer,
                address: {
                  ...editableInvoice.buyer.address,
                  city: e.target.value,
                },
              })
            }
            fullWidth
            disabled={isDisabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            options={provinces}
            getOptionLabel={(option) => option.name || ""}
            value={provinceValue}
            onChange={(event, newValue) =>
              handleInputChange("buyer", {
                ...editableInvoice.buyer,
                address: {
                  ...editableInvoice.buyer.address,
                  province: newValue ? newValue.name : "",
                },
              })
            }
            freeSolo
            renderInput={(params) => (
              <TextField
                {...params}
                label="Province"
                fullWidth
                disabled={isDisabled}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Postal Code"
            value={editableInvoice.buyer.address.postalCode || ""}
            onChange={(e) =>
              handleInputChange("buyer", {
                ...editableInvoice.buyer,
                address: {
                  ...editableInvoice.buyer.address,
                  postalCode: e.target.value,
                },
              })
            }
            fullWidth
            disabled={isDisabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            options={countries}
            getOptionLabel={(option) => option.name || ""}
            value={countryValue}
            onChange={(event, newValue) =>
              handleInputChange("buyer", {
                ...editableInvoice.buyer,
                address: {
                  ...editableInvoice.buyer.address,
                  country: newValue ? newValue.isoCode || newValue.name : "",
                  province: "",
                },
              })
            }
            freeSolo
            renderInput={(params) => (
              <TextField
                {...params}
                label="Country"
                fullWidth
                disabled={isDisabled}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {stripePaymentEnabled && documentType !== "Estimate" && (
            <FormControl component="fieldset" sx={{ mt: 2 }}>
              <FormLabel
                component="legend"
                sx={{ fontWeight: "bold", fontSize: "16px" }}
              >
                Accept Online Payments?
              </FormLabel>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <RadioGroup
                  name="sendStripePaymentUrl"
                  value={editableInvoice.sendStripePaymentUrl || "no"}
                  onChange={(e) =>
                    handleInputChange("sendStripePaymentUrl", e.target.value)
                  }
                  row
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                    sx={{
                      color: "black",
                      "& .MuiRadio-root": { color: "green" },
                      "& .MuiTypography-root": { fontWeight: "500" },
                    }}
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="No"
                    sx={{
                      color: "black",
                      "& .MuiRadio-root": { color: "red" },
                      "& .MuiTypography-root": { fontWeight: "500" },
                    }}
                  />
                </RadioGroup>
                <label className="d-flex gap-2 cursor-pointer">
                  <img
                    src="/assets/images/payment/visa.webp"
                    className="img-fluid"
                    alt="Visa"
                    style={{ maxWidth: "50px" }}
                  />
                  <img
                    src="/assets/images/payment/american-express.webp"
                    className="img-fluid"
                    alt="American Express"
                    style={{ maxWidth: "50px" }}
                  />
                  <img
                    src="/assets/images/payment/master.webp"
                    className="img-fluid"
                    alt="MasterCard"
                    style={{ maxWidth: "50px" }}
                  />
                </label>
              </Box>
            </FormControl>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default BuyerInfoForm;